import { useMutation, useQueryClient } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

export function useWithdrawTeamEntry(tournamentId: string) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (entryId: string) => tournamentApi.withdrawTeamEntry(entryId),
    onSettled: () =>
      Promise.all([
        client.invalidateQueries({
          queryKey: queryKeys.tournaments.myTeamEntries(),
        }),
        client.invalidateQueries({
          queryKey: queryKeys.tournaments.myRegistrations(),
        }),
        client.invalidateQueries({
          queryKey: queryKeys.tournaments.events(tournamentId),
        }),
      ]),
  });
}
